// extracted by mini-css-extract-plugin
export default {"goodsContent":"ng_detail_goodsContent__Wy7Cj","tab__panel":"ng_detail_tab__panel__5HmEa","tab__panel--active":"ng_detail_tab__panel--active__Z0WII"};